import Vue from 'vue'
import Router from 'vue-router'
import AppLayout from '@/components/app-layout'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: AppLayout,
      redirect: { name: 'home' },
      children: [
        {
          path: 'home',
          name: 'home',
          component: r => require(['@/pages/home'], r)
        },
        {
          path: 'service',
          name: 'service',
          component: r => require(['@/pages/service'], r)
        },
        {
          path: 'appointment',
          name: 'appointment',
          component: r => require(['@/pages/appointment'], r),
          redirect: { name: 'appointment-advisory' },
          children: [
            {
              path: 'advisory',
              name: 'appointment-advisory',
              component: r => require(['@/pages/appointment-advisory'], r)
            },
            {
              path: 'question',
              name: 'appointment-question',
              component: r => require(['@/pages/appointment-question'], r)
            }
          ]
        },
        {
          path: 'news',
          name: 'news',
          component: r => require(['@/pages/news'], r)
        },
        {
          path: 'news/detail',
          name: 'news-detail',
          component: r => require(['@/pages/news-detail'], r)
        },
        {
          path: 'news/search/result',
          name: 'news-search-result',
          component: r => require(['@/pages/news-search-result'], r)
        },
        {
          path: 'about',
          name: 'about',
          component: r => require(['@/pages/about'], r),
          redirect: { name: 'about-introduce' },
          children: [
            {
              path: 'introduce',
              name: 'about-introduce',
              component: r => require(['@/pages/about-introduce'], r)
            }
          ]
        },
        {
          path: 'doctor/detail',
          name: 'doctor-detail',
          component: r => require(['@/pages/doctor-detail'], r)
        }
      ]
    },
    {
      path: '*',
      component: AppLayout,
      children: [{
        path: '',
        name: '404',
        component: r => require(['@/pages/404'], r)
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js